'use client'

import TopBanner from "@/components/etc/top_banner"
import { BannerContext } from "@/context/bannerContext"
import { useContext } from "react"

export default function MainTopBanners(){
    const { main_top_banner } = useContext(BannerContext)
    
    return (
        <div className="main-top-banners">
            <TopBanner bannerUrl={main_top_banner[1]} />
            <TopBanner bannerUrl={main_top_banner[2]} />
        </div>
    )
}